(function () {
    'use strict';

    angular.module("imApp").factory("carrierService", ['$ihttp', function ($ihttp) {
        let service = {
            getCarrier: function (parms) {
                return $ihttp.post({
                    method: 2665,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2666,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
